/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digital_LibraryInputs */

const en_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Library`)
};

const es_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca digital`)
};

const fr_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothèque numérique`)
};

const de_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Bibliothek`)
};

const ja_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルライブラリ`)
};

const zh_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字图书馆`)
};

const ar_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المكتبة الرقمية`)
};

const id_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka Digital`)
};

const it_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libreria Digitale`)
};

const ru_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровая библиотека`)
};

const pt_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca Digital`)
};

const ko_digital_library = /** @type {(inputs: Digital_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 라이브러리`)
};

/**
* | output |
* | --- |
* | "Digital Library" |
*
* @param {Digital_LibraryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const digital_library = /** @type {((inputs?: Digital_LibraryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digital_LibraryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_digital_library(inputs)
	if (locale === "es") return es_digital_library(inputs)
	if (locale === "fr") return fr_digital_library(inputs)
	if (locale === "de") return de_digital_library(inputs)
	if (locale === "ja") return ja_digital_library(inputs)
	if (locale === "zh") return zh_digital_library(inputs)
	if (locale === "ar") return ar_digital_library(inputs)
	if (locale === "id") return id_digital_library(inputs)
	if (locale === "it") return it_digital_library(inputs)
	if (locale === "ru") return ru_digital_library(inputs)
	if (locale === "pt") return pt_digital_library(inputs)
	return ko_digital_library(inputs)
});